<template>
    <section class="grouping-timers" aria-label="Tempos do agrupamento">
        <div>
            <small>Tempo total</small>
            <strong>{{ formatDuration(totalSeconds) }}</strong>
        </div>
        <div>
            <small>Setup</small>
            <strong>{{ formatDuration(setupSeconds) }}</strong>
        </div>
        <div>
            <small>Execução</small>
            <strong>{{ formatDuration(runningSeconds) }}</strong>
        </div>
        <div>
            <small>Parada</small>
            <strong>{{ formatDuration(stoppedSeconds) }}</strong>
        </div>
        <div class="grouping-timers__current">
            <small>Status</small>
            <strong>{{ currentStatusLabel }}</strong>
            <span>{{ formatDuration(currentSeconds) }}</span>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        grouping: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            now: Date.now(),
            loadedAt: Date.now(),
            timer: null
        };
    },
    computed: {
        liveSeconds() {
            if (this.grouping.status !== "INPROGRESS" && this.grouping.status !== "IN_PROGRESS") return 0;
            return Math.max(0, Math.floor((this.now - this.loadedAt) / 1000));
        },
        currentKind() {
            const name = String(this.grouping.currentStatusName || "").toLocaleLowerCase("pt-BR");
            if (name === "setup") return "setup";
            if (["executando", "running"].includes(name)) return "running";
            if ([2, 3].includes(Number(this.grouping.currentStatusClassificationId))) return "stopped";
            return "other";
        },
        currentStatusLabel() {
            const name = String(this.grouping.currentStatusName || "").trim();
            if (["executando", "running"].includes(name.toLocaleLowerCase("pt-BR")))
                return "Em andamento";
            return name || "Aguardando";
        },
        totalSeconds() {
            return Number(this.grouping.totalElapsedSeconds || 0) + this.liveSeconds;
        },
        setupSeconds() {
            return Number(this.grouping.setupElapsedSeconds || 0) + (this.currentKind === "setup" ? this.liveSeconds : 0);
        },
        runningSeconds() {
            return Number(this.grouping.runningElapsedSeconds || 0) + (this.currentKind === "running" ? this.liveSeconds : 0);
        },
        stoppedSeconds() {
            return Number(this.grouping.stoppedElapsedSeconds || 0) + (this.currentKind === "stopped" ? this.liveSeconds : 0);
        },
        currentSeconds() {
            return Number(this.grouping.currentStatusElapsedSeconds || 0) + this.liveSeconds;
        }
    },
    watch: {
        grouping() {
            this.loadedAt = Date.now();
            this.now = this.loadedAt;
        }
    },
    mounted() {
        this.timer = window.setInterval(() => {
            this.now = Date.now();
        }, 1000);
    },
    beforeDestroy() {
        window.clearInterval(this.timer);
    },
    methods: {
        formatDuration(value) {
            const seconds = Math.max(0, Math.floor(Number(value || 0)));
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainder = seconds % 60;
            return [hours, minutes, remainder].map(part => String(part).padStart(2, "0")).join(":");
        }
    }
};
</script>

<style lang="scss" scoped>
.grouping-timers {
    display: grid;
    grid-template-columns: repeat(5, minmax(120px, 1fr));
    border: 1px solid #d8d6de;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;

    > div {
        min-height: 68px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 14px;

        + div { border-left: 1px solid #ece0db; }
    }

    small { color: #998f8a; }
    strong { margin-top: 3px; color: #4c4541; font-size: 17px; }
    span { margin-top: 2px; color: #7e7570; font-size: 12px; }

    &__current { border-top: 3px solid #f3811a; }
}

@media (max-width: 800px) {
    .grouping-timers {
        grid-template-columns: repeat(2, 1fr);
        > div { border-bottom: 1px solid #ece0db; }
        &__current { grid-column: 1 / -1; }
    }
}
</style>
